import axios from 'axios'

export default {
  addAddress (payload) {
    return axios.post('/api/address', payload)
  },
  updateAddress (id, data) {
    return axios.patch(`/api/address/${id}/update`, data)
  },
  deleteAddress (id, data) {
    return axios.delete(`/api/address/${id}/destroy`, {data})
  },
  updateCompanyRelation (companyId, payload) {
    return axios.patch(`/api/company/company-relation/${companyId}`, payload)
  },
  fetchFiltersTabData () {
    return axios.get('/api/company/get-filter-tabs-data')
  },
  fetchAdminContacts (params) {
    return axios.get('/api/company/get-all-contacts-by-user', { params })
  },
  fetchCountries () {
    return axios.get('/api/countries')
  }
}
